import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CampaignAnalyticsDto } from "../../../models/campaign/dto/campaign.dto";

export const GET_CAMPAIGN_ANALYTICS_QUERY_KEY = (id: string) => ['campaigns', id, 'analytics'];

export const useGetCampaignAnalytics = (campaignId: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_CAMPAIGN_ANALYTICS_QUERY_KEY(campaignId),
        queryFn: () => client.fetchApi<CampaignAnalyticsDto, {}>({
            endpoint: `campaigns/admin/${campaignId}/analytics`,
            method: 'GET'
        }),
        staleTime: 30_000,
        enabled: !!campaignId,
    });
};
